module.exports = __webpack_public_path__ + "img/fa-6@3x.1019e6c9.png";